import { JSX, useState } from 'react';
import './menuButton.css';

interface MenuItemProps {
    title: string,
    isChosen: boolean,
    onClick: ()=> void
}

const MenuButton = ({ title, isChosen, onClick, }: MenuItemProps ): JSX.Element => {
    return (
        <p className={isChosen? 'addPage-menu-item-chosen':'addPage-menu-item' } data-text={title} onClick={onClick}>{title}</p>
    ); 
};
  
export default MenuButton;